import type {
  AssignmentDetails,
  Dossier,
  Finding,
  ReservationResponse,
  SnoozeDetails,
} from '@owl-frontend/api-client/interface';
import { AsyncActionState, setupSlice } from '@owl-frontend/redux';

export interface DossierDetailsState {
  dossiers: {
    [dossierId: string]: Dossier;
  };
  findings: {
    [dossierId: string]: Finding[];
  };
  assignmentCount: {
    count: number;
    maxReassignments: number;
  };
  snoozeCount: {
    count: number;
    maxSnoozes: number;
  };
  reservationDetails: {
    [dossierId: string]: ReservationResponse & {
      assignmentDetails?: AssignmentDetails;
      snoozeDetails?: SnoozeDetails['snoozeDetails'];
    };
  };
  actions: {
    fetchDossierDetails: AsyncActionState;
    setFindingDecision: AsyncActionState;
    assignmentCount: AsyncActionState;
    assignDossier: AsyncActionState;
    fetchDossierFindings: AsyncActionState;
    concludeDossier: AsyncActionState<Dossier>;
    doneDossier: AsyncActionState;
    closeDossier: AsyncActionState;
    snoozeCount: AsyncActionState;
    snoozeDossier: AsyncActionState;
    reservationDetails: AsyncActionState;
  };
}

const initialState: DossierDetailsState = {
  dossiers: {},
  findings: {},
  assignmentCount: {
    count: 0,
    maxReassignments: 0,
  },
  snoozeCount: {
    count: 0,
    maxSnoozes: 0,
  },
  reservationDetails: {},
  actions: {
    fetchDossierDetails: { status: 'uninitialized' },
    setFindingDecision: { status: 'uninitialized' },
    assignmentCount: { status: 'uninitialized' },
    assignDossier: { status: 'uninitialized' },
    snoozeCount: { status: 'uninitialized' },
    snoozeDossier: { status: 'uninitialized' },
    fetchDossierFindings: { status: 'uninitialized' },
    concludeDossier: { status: 'uninitialized' },
    doneDossier: { status: 'uninitialized' },
    closeDossier: { status: 'uninitialized' },
    reservationDetails: { status: 'uninitialized' },
  },
};

const dossierDetailsSlice = setupSlice('dossier-details', initialState);
export default dossierDetailsSlice;
